import React from 'react';
import { Construction } from 'lucide-react';

/**
 * UnderDevelopmentModal Component
 * What: Reusable modal to show when features are under development
 * Why: Provides consistent user feedback across the application for unimplemented features
 * Where: shared/components/ui/UnderDevelopmentModal.js
 * 
 */
export const UnderDevelopmentModal = ({ onClose, featureName = 'This feature' }) => {
  return (
    <div className="text-center">
      <div className="mx-auto flex items-center justify-center w-16 h-16 bg-yellow-100 rounded-full mb-4">
        <Construction className="w-8 h-8 text-yellow-600" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        Under Development
      </h3>
      <p className="text-gray-600 mb-6">
        {featureName} is currently being developed. We're working hard to bring you the best experience!
      </p>
      <button
        onClick={onClose}
        className="w-full px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
      >
        Got it
      </button>
    </div>
  );
};
